/**
 * Filter Constants
 * Centralized configuration for smart filter functionality
 */

// Filter operators
export const FILTER_OPERATORS = {
  EQUALS: "equals",
  CONTAINS: "contains",
  GTE: "gte",
  LTE: "lte",
  IN: "in",
  OR: "OR",
  AND: "AND",
};

// Default searchable fields for global search
export const SEARCHABLE_FIELDS = [
  "company",
  "name",
  "email",
  "phone",
  "brandMake",
  "model",
];

// Default select fields for API queries
export const DEFAULT_SELECT_FIELDS = [
  "id",
  "company",
  "name",
  "email",
  "phone",
  "contacted",
  "contactedBy",
  "dealStatus",
  "totalSavings",
  "createdAt",
];

// Pagination defaults
export const PAGINATION_DEFAULTS = {
  PAGE: 1,
  LIMIT: 10,
};

// Debounce timing
export const TIMING = {
  DEBOUNCE_MS: 300,
  TOAST_DURATION: 3000,
};

// Toast messages
export const TOAST_MESSAGES = {
  FILTER_ADDED: (field, operator, value) =>
    `Filter added: ${field} ${operator} ${value}`,
  FILTER_REMOVED: "Filter removed",
  ALL_FILTERS_CLEARED: "All filters cleared",
  PRESET_APPLIED: (name) => `Filter preset "${name}" applied`,
  PRESET_SAVED: (name) => `Filter preset "${name}" saved successfully`,
  PRESET_DELETED: "Filter preset deleted successfully",
  INVALID_FILTER: "Invalid filter parameters",
  INVALID_INDEX: "Invalid filter index",
  INVALID_PRESET: "Invalid filter preset",
  PRESET_NAME_REQUIRED: "Preset name is required",
  PRESET_ID_REQUIRED: "Preset ID is required",
  INIT_FAILED: (error) => `Failed to initialize filters: ${error}`,
  FETCH_FAILED: (error) => `Failed to fetch leads: ${error}`,
  SAVE_FAILED: (error) => `Failed to save preset: ${error}`,
  DELETE_FAILED: (error) => `Failed to delete preset: ${error}`,
  STATS_FAILED: (error) => `Failed to get filter statistics: ${error}`,
};

// Filter types for UI organization
export const FILTER_TYPES = {
  BOOLEAN: "booleanFilters",
  DROPDOWN: "dropdownFilters",
  STRING: "stringFilters",
  NUMBER: "numberFilters",
  DATE: "dateFilters",
};

// Sort options
export const SORT_OPTIONS = {
  CREATED_AT_DESC: { field: "createdAt", direction: "desc" },
  CREATED_AT_ASC: { field: "createdAt", direction: "asc" },
  NAME_ASC: { field: "name", direction: "asc" },
  NAME_DESC: { field: "name", direction: "desc" },
  SAVINGS_DESC: { field: "totalSavings", direction: "desc" },
  SAVINGS_ASC: { field: "totalSavings", direction: "asc" },
};

// Deal Status Options
export const DEAL_STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "contacted", label: "Contacted" },
  { value: "interested", label: "Interested" },
  { value: "quoted", label: "Quoted" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
  { value: "closed won", label: "Closed Won" },
  { value: "closed lost", label: "Closed Lost" },
  { value: "no response", label: "No Response" },
];

// Helper function to get capitalized deal status label
export const getDealStatusLabel = (status) => {
  const statusOption = DEAL_STATUS_OPTIONS.find(
    (option) => option.value === status
  );
  return statusOption ? statusOption.label : "Open";
};
